import { Locale } from '../../types';

const formatIncompleteDOB = (
  value?: RegExpMatchArray,
  isLocaleBrazil?: boolean,
) => (isLocaleBrazil ? `${value[2]}/${value[1]}` : `${value[1]}/${value[2]}`);

const formatFullDOB = (value?: RegExpMatchArray, isLocaleBrazil?: boolean) =>
  isLocaleBrazil
    ? `${value[2]}/${value[1]}/${value[3]}`
    : `${value[1]}/${value[2]}/${value[3]}`;

/**
 * Normalize the date of birth according to US or BR format
 * @category Formatters
 * @category Date-Time
 */
export function normalizeDOB(value?: string, locale?: string) {
  const newValue = value?.match(/(\d{1,2})\/(\d{1,2})\/?(\d{4}|\d{2})?/);

  if (!newValue || !value || !value.includes('/')) {
    return value;
  }

  const isLocaleBrazil = locale === Locale.PortugueseBR;

  // the api has no support for dd/mm/yyyy format
  // we need to check the locale and change to mm/dd/yyyy format before to do the search request
  // more info: https://wiki.lumahealth.io/en/engineering/tools/patient-search
  if (!newValue[3]) {
    return formatIncompleteDOB(newValue, isLocaleBrazil);
  }

  return formatFullDOB(newValue, isLocaleBrazil);
}
